export * from './youtube-video'

/**
 * Check if a URL is a YouTube video that can be embedded.
 * We use a hack to check if the URL is embeddable by checking if it has the query parameter `v2_embed=true`.
 * This is due to current limitations in the number of content types we have in Contentful.
 **/
export const YOUTUBE_REGEX =
  /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^\s"&/?]{11})\?v2_embed=true/

export const isYoutubeEmbeddable = (url: string): boolean =>
  new URL(url).searchParams.has('v2_embed')
